var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-footer kt-grid__item",attrs:{"id":"kt_footer"}},[_c('div',{staticClass:"kt-container"},[_c('div',{staticClass:"kt-footer__wrapper"},[_c('div',{staticClass:"kt-footer__copyright"},[_vm._t("footer_copyright")],2),_c('div',{staticClass:"kt-footer__menu"},[_vm._t("footer_menu")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }